module.exports = __webpack_public_path__ + "static/img/NL.edf87ec1.jpg";